<template>
  <ul>
    <li>
      <EvaluateParameter
        :value="calcFeePercentage.evaluateParameter"
        :parameterTypesMap="parameterTypesMap"
      />
      <EvaluateLogs :logs="calcFeePercentage.logs" />
    </li>
  </ul>
</template>

<script>
import EvaluateLogs from "@/components/quote/evaluate/Logs";
import EvaluateParameter from "@/components/quote/evaluate/Parameter";
export default {
  name: "EvaluateCalcFeePercentage",
  props: ["calcFeePercentage", "parameterTypesMap"],
  components: {
    EvaluateLogs,
    EvaluateParameter
  }
};
</script>